import { StringSchema, string as YupString, addMethod } from 'yup';
/* eslint-disable no-unused-vars, autofix/no-unused-vars */

/**
 * Declare typedef for isNang
 * @see https://github.com/jquense/yup/issues/312
 */
declare module 'yup' {
  interface StringSchema {
    /**
     * Verifies comma separated list are valid emails
     * @param message Message to show on error
     */
    checkFileSize(sizeLimit: number, message: string): StringSchema;
  }
}

/**
 * Write custom validator for Yup checking for file size below sizeLimit
 *
 * @example
 *  import '../../../../../common/formik-material-ui/checkFileSize';
 *
 *  const QueueEditSchema = Yup.object({
 *    submitQueueEditPayload: Yup.object({
 *      email: Yup.string().checkFileSize('Invalid email'),
 *    }),
 *  });
 */
addMethod<StringSchema>(YupString, 'checkFileSize', function (
  this: StringSchema<any>,
  sizeLimit: number,
  message: string
) {
  return this.test('is-file-below-limit', message, function (value: string) {
    const { path } = this;

    // exit if conditions are not met
    if (typeof sizeLimit !== 'number' || !value) {
      return true;
    }

    // get value of file size from formated number: filename.mp3|size:1_123_435
    const parts = value?.split(':');
    const fileSize = Number(parts[parts.length - 1]);

    return (
      Number.isNaN(fileSize) || // true if fileSize is not a number
      fileSize <= sizeLimit || // true if file size is less than or equal to sizeLimit
      this.createError({
        path,
        message,
      }) // otherwise error
    );
  });
});
